export default "__VITE_ASSET__CGdOvVGj__"